import { COLORS, Col, FlexView, Row } from '@cuemath/comps';
import React from 'react';
import styled from 'styled-components';
import LAYOUT from 'constants/layout';
import { Button, Text } from '@cuemath/web-comps';
import useLogic from './TimeSlot.logic';

const TimeSlotWrapper = styled(Col)`
  border: 1px solid ${COLORS.BG_GHOST};
  width: 200px;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s ease all;
  background: ${({ isDisabled }) => (isDisabled ? COLORS.BG_GHOST : null)};
  &:hover {
    background: ${COLORS.BG_GHOST};
  }
`;
const GreenDot = styled(FlexView)`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: ${COLORS.GRASS};
  margin-left: 8px;
`;

const TimeSlot = ({ slotStartTime, teachers, isHighlighted, slotEndTime, date }) => {
  const { openTeachersListingModal, isDisabled } = useLogic({
    teachers,
    slotStartTime,
    date,
    slotEndTime,
  });

  return (
    <TimeSlotWrapper
      gutter={LAYOUT.GUTTER}
      gap={16}
      onClick={openTeachersListingModal}
      isDisabled={isDisabled}
      alignItems="center"
      justifyContent="center"
    >
      <Text variant="h5" align="center">
        {slotStartTime}
      </Text>
      <Row alignItems="center" justifyContent="center">
        <Button
          textVariant="body1Regular"
          variant="tertiaryWithUnderline"
          label={`${teachers?.length} available`}
          size="small"
          isDisabled={isDisabled}
        />

        {isHighlighted && <GreenDot />}
      </Row>
    </TimeSlotWrapper>
  );
};

export default TimeSlot;
